import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ListView from './views/ListView';
import { CreateForm, EditForm } from './views/FormView';
import {
  CreateForm as AddAthleteForm,
  EditForm as EditAthleteForm,
} from '../CertificationAthlete/views/FormView';
import AthleteList from '../CertificationAthlete/views/ListView';
import Statement from '../CertificationAthlete/views/Statement';
import Protocol from '../CertificationAthlete/views/Protocol';
import Statistics from '../CertificationAthlete/views/Statistics';
import ListAthlete from '../CertificationAthlete/views/ListAthlete';
import ListAthleteProtocols from '../CertificationAthlete/views/ListAthleteProt';
import BaseLayout from '../../components/CabinetBaseLayout';
import useApi from '../../api';

const Component = () => {
  const api = useApi();
  const router = api.router.certifications;
  return (
    <BaseLayout>
      <Switch>
        <Route exact path={router.athleteList(':id')} component={AthleteList} />
        <Route
          exact
          path={router.addAthlete(':id')}
          component={AddAthleteForm}
        />
        <Route exact path={router.Statement(':id')} component={Statement} />
        <Route exact path={router.Protocol(':id')} component={Protocol} />
        <Route exact path={router.Statistics(':id')} component={Statistics} />
        <Route
          exact
          path={router.ListAthlete(':id', ':trainerId')}
          component={ListAthlete}
        />
        <Route
          exact
          path={router.ListAthleteProt(':id', ':rank', ':protocolId')}
          component={ListAthleteProtocols}
        />
        <Route
          exact
          path={router.editAthlete(':certificationsId', ':id')}
          component={() => <EditAthleteForm />}
        />
        <Route exact path={router.list()} component={ListView} />
        <Route exact path={router.create()} component={CreateForm} />
        <Route path={router.edit(':id')} component={EditForm} />
      </Switch>
    </BaseLayout>
  );
};

export default Component;
